/**
 * Betyg som text: "4,5" på svenska, "4.5" på engelska. Förut skrevs Googles
 * betyg med punkt även på de svenska sidorna ("4.5/5 på Google").
 */
export function betygText(v: number, locale: string): string {
  return v.toLocaleString(locale === 'sv' ? 'sv-SE' : 'en-GB', { minimumFractionDigits: 1, maximumFractionDigits: 1 });
}
